import React from 'react';
import { Loader2 } from 'lucide-react';
import { LoaderProps } from './LoaderProps.d';


const Loader: React.FC<LoaderProps> = ({
    isLoading = true,
    className = '',
    size = 24,
    text,
    withBackdrop = false, // Default value is false
}) => {
    if (!isLoading) return null;

    return (
        <>
            {withBackdrop && (
                <div className="fixed inset-0 bg-black/50 z-40">



                </div>
            )}
            
            <div className={`inline-flex items-center gap-3 ${className} z-50`}>
                <Loader2 size={size} className={`animate-spin duration-500 text-brandColor`} />
                {text && <span className={`text-sm text-brandColor`}>{text}</span>}
            </div>
        </>
    );
};

export default Loader;


